var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.1,13.06C24.38-3.4.62,2.87,6.26,18.53h-.1c-8.21.58-8.21,12.53,0,13.11-1.04-1.76-.99-4.05.31-5.78,1.72-2.3,5-2.77,7.3-1.05l.74.55,5.95-6.7c.93-1.04,2.2-1.66,3.59-1.74,1.38-.07,2.73.38,3.77,1.31,1.04.92,1.66,2.2,1.74,3.59.08,1.39-.38,2.73-1.31,3.77h0s-5.37,6.04-5.37,6.04h2.74c2.37.02,4.63-.86,6.39-2.46,5.75-5.04,2.68-15.15-4.92-16.13Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.64,23.27c.63-.71.57-1.79-.14-2.42s-1.79-.57-2.42.14l-8.09,9.11-3.31-2.48c-.76-.57-1.83-.41-2.4.34-.57.76-.41,1.83.34,2.4l4.57,3.43c.71.53,1.72.43,2.31-.23l9.14-10.29h0Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOn);
export default __webpack_public_path__ + "static/media/cloud_on.ebc13b80b220c40f1515dc31182e7714.svg";
export { ForwardRef as ReactComponent };